import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import produce from 'immer';
export var withLoadingLogic = function withLoadingLogic(setState) {
  return function (promise) {
    setIsLoading(true, setState);
    return promise.finally(function () {
      setIsLoading(false, setState);
    });
  };
};
export var withProcessingLogic = function withProcessingLogic(setState) {
  return function (promise) {
    setIsProcessing(true, setState);
    return promise.finally(function () {
      setIsProcessing(false, setState);
    });
  };
};
export var setIsLoading = function setIsLoading(isLoading, setState) {
  setState(produce(function (draft) {
    draft.isLoading = isLoading;
  }));
};
export var setIsProcessing = function setIsProcessing(isProcessing, setState) {
  setState(produce(function (draft) {
    draft.isProcessing = isProcessing;
  }));
};
export var wait = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(interval) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return new Promise(function (res) {
            setTimeout(function () {
              res(undefined);
            }, interval);
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function wait(_x) {
    return _ref.apply(this, arguments);
  };
}();